import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, BreadcrumbTrail } from '@americanexpress/dls-react';
import { Link } from '@americanexpress/one-app-router';

const textDecorationNone = {
  '> a': {
    textDecoration: 'none',
  },
};

export const FxBreadcrumbs = ({ breadcrumbItems }) => {
  const currentPath = window.location.pathname;

  const handleReload = (path) => {
    if (currentPath === path) window.location.reload();
  };

  return (
    <BreadcrumbTrail id="BreadcrumbTrail">
      {breadcrumbItems.map((data, index, array) => (index === array.length - 1 ? (
        <Breadcrumb
          aria-current="page"
          key={data.id}
          id={`${data.id}-Breadcrumb`}
        >
          {data.name}
        </Breadcrumb>
      ) : (
        <Breadcrumb
          key={data.id}
          id={`${data.id}-Breadcrumb`}
          href={data.pathname}
          theme={textDecorationNone}
          onClick={() => handleReload(data.pathname)}
        >
          <Link to={data.pathname}>{data.name}</Link>
        </Breadcrumb>
      ))
    )}
    </BreadcrumbTrail>
);
      };

FxBreadcrumbs.displayName = 'FxBreadcrumbs';

FxBreadcrumbs.propTypes = {
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      pathname: PropTypes.string,
      onClick: PropTypes.func,
    }).isRequired
  ),
};
